import React from "react";
import { Paperclip, Sparkles, Mic, Send, X } from "lucide-react";

const AIInputBox = ({
  query,
  setQuery,
  onSubmit,
  onClear,
  loading,
  listening,
  onToggleMic,
  onOpenLanguageMenu,
  showLangMenu,
  languages,
  onSelectLanguage,
  theme = "light",
  onQuickPrompt,
}) => {
  const isDark = theme === "dark";
  return (
    <form
      onSubmit={onSubmit}
      className={`rounded-2xl border p-3 shadow-sm ${
        isDark ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white"
      }`}
    >
      <div className="relative">
        <textarea
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          rows={1}
          placeholder="Describe the report you need (e.g., Show last month's created order details)..."
          className={`w-full resize-none bg-transparent px-2 pr-8 text-sm outline-none ${
            isDark ? "text-slate-100 placeholder:text-slate-500" : "text-slate-800 placeholder:text-slate-400"
          }`}
          onInput={(e) => {
            e.target.style.height = "auto";
            e.target.style.height = `${e.target.scrollHeight}px`;
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              const form = e.target.closest("form");
              if (form) form.requestSubmit();
            }
          }}
        />
      </div>

      <div className="mt-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <button
            type="button"
            disabled
            className="hidden cursor-not-allowed rounded-xl bg-[#cc0452]/40 p-2 text-white/70"
            title="Attach"
          >
            <Paperclip size={16} />
          </button>
          <button
            type="button"
            onClick={onQuickPrompt}
            className="hidden rounded-xl bg-[#cc0452] p-2 text-white transition hover:brightness-110"
            title="Quick prompt"
          >
            <Sparkles size={16} />
          </button>
        </div>

        <div className="flex items-center gap-3">
          {query.trim() && (
            <button
              type="button"
              onClick={onClear}
              className="rounded-xl bg-[#cc0452] p-2 text-white transition hover:brightness-110"
              title="Clear"
            >
              <X size={16} />
            </button>
          )}
          <div className="relative">
            <button
              type="button"
              onClick={onToggleMic}
              onContextMenu={onOpenLanguageMenu}
              className={`rounded-xl px-3 py-2 text-sm font-semibold transition ${
                listening
                  ? "bg-[#cc0452] text-white ring-2 ring-[#cc0452]/40"
                  : "bg-[#cc0452] text-white hover:brightness-110"
              }`}
              title="Voice input (right click to change language)"
            >
              <Mic size={16} />
            </button>
            {showLangMenu && (
              <div
                className={`absolute right-0 top-12 z-50 w-40 space-y-2 rounded-xl border p-2 text-xs shadow ${
                  isDark ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white"
                }`}
              >
                {languages.map((lang) => (
                  <button
                    key={lang.code}
                    type="button"
                    onClick={() => onSelectLanguage(lang)}
                    className="w-full rounded-lg bg-[#7e6ff5] px-3 py-2 text-left text-white transition hover:brightness-110"
                  >
                    {lang.name}
                  </button>
                ))}
              </div>
            )}
          </div>
          <button
            type="submit"
            disabled={loading || !query.trim()}
            className={`hidden rounded-xl px-4 py-2 text-sm font-semibold transition ${
              loading || !query.trim()
                ? "cursor-not-allowed border border-slate-200 text-slate-700"
                : "bg-[#cc0452] text-white hover:brightness-110"
            }`}
          >
            Generate
          </button>
          <button
            type="button"
            onClick={onSubmit}
            disabled={loading || !query.trim()}
            className={`rounded-xl p-2 transition ${
              loading || !query.trim()
                ? "cursor-not-allowed border border-slate-200 text-slate-700"
                : "bg-[#cc0452] text-white hover:brightness-110"
            }`}
            title="Send"
          >
            <Send size={16} />
          </button>
        </div>
      </div>
    </form>
  );
};

export default AIInputBox;
